//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// === COMPONENTS ===
import { Document } from './components/Document';

//#endregion

const DocMemo = React.memo( Document );

//-----------------------------------------------------------------
export function Thumbnails( {documents, images} ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  
  //#endregion

  //#region [STYLES]

  const _styles = {
    thumb_paper: {
      gridColumn: 'span 2',
      overflow : 'auto'     ,
      position : 'relative' ,
      height   : '100%',
      width    : '100%',
      boxShadow: 0,
      backgroundColor: theme.palette.background.secondary[theme.palette.mode],
    },
    document_container: {
      height: '100%', width: '100%', overflow: 'auto',
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const thumb_documents = documents.order.map( displayDocument );
    
    return (
      <Box sx={_styles.thumb_paper}>
        <Box sx={_styles.document_container} >
          { thumb_documents }
        </Box>
      </Box>
    );
  }
  
  //-----------------------------------------------------------------
  function displayDocument( id, index ) {
    //-----------------------------------------------------------------
    const document = documents.items[id];    
    if( !document ) {
      console.log( `Failed to get document with id [${id}].`);
    }
    const timestamp = document?.timestamp;    
    return (
      <Box>
        <DocMemo key={ 'd' + id } id={ id } timestamp={timestamp} index={index} images={images.order} />       
      </Box>  
      );
    }

  //#endregion

  return display();
}
